<!-- Loading State -->
<div *ngIf="isLoading" class="bg-[var(--light-grey)]">
  <div class="mx-auto max-w-screen-desktop container-padding py-8">
    <div class="flex flex-col gap-4">
      <app-skeleton *ngFor="let i of [1,2,3]" dimensions="w-full h-[110px] rounded-xl"></app-skeleton>
    </div>
  </div>
</div>

<!-- No Events -->
<div *ngIf="!isLoading && events.length === 0" class="py-8 bg-[var(--light-grey)]">
  <div class="mx-auto max-w-screen-desktop container-padding py-12 text-center">
    <div class="flex flex-col items-center gap-4">
      <div class="w-16 h-16 rounded-full bg-[var(--grey)] flex items-center justify-center">
        <fa-icon [icon]="faCalendarAlt" class="text-[var(--dark-grey)] text-2xl"></fa-icon>
      </div>
      <p class="text-[16px] font-[400] text-[var(--dark-grey)]">{{ 'events.noEvents' | translate }}</p>
    </div>
  </div>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading && events.length > 0" class="events-showcase" [class.events-showcase--compact]="compact">
  
  <!-- Filters -->
  <div *ngIf="showFilters" class="events-showcase__filters">
    <div class="mx-auto max-w-screen-desktop container-padding">
      <div class="flex flex-col mobile-m:flex-row gap-3 items-stretch mobile-m:items-center">
        <!-- Search -->
        <div class="relative flex-1 max-w-[320px]">
          <fa-icon [icon]="faSearch" class="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--dark-grey)] text-sm"></fa-icon>
          <input 
            type="text"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            placeholder="{{ 'eventsShowcase.searchPlaceholder' | translate }}"
            class="showcase-filter-input pl-10 pr-4"
          />
        </div>
        
        <!-- Location Filter -->
        <div class="relative flex-1 max-w-[360px]">
          <fa-icon [icon]="faMapMarkerAlt" class="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--dark-grey)] text-sm"></fa-icon>
          <select 
            [ngModel]="selectedLocationFilter"
            (ngModelChange)="onLocationFilterChange($event)"
            class="showcase-filter-input pl-10 pr-8 appearance-none cursor-pointer">
            <option value="">{{ 'eventsShowcase.allLocations' | translate }}</option>
            <option *ngFor="let loc of locationFilters" [value]="loc.address">
              {{ loc.address }}
            </option>
          </select>
          <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg class="w-4 h-4 text-[var(--dark-grey)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>

        <!-- Clear -->
        <button 
          *ngIf="hasActiveFilters"
          (click)="clearFilters()"
          class="showcase-clear-btn">
          <fa-icon [icon]="faTimes" class="mr-1"></fa-icon>
          {{ 'eventsShowcase.clear' | translate }}
        </button>
      </div>

      <div class="mt-2 h-4 flex items-center">
        <span *ngIf="hasActiveFilters" class="text-xs text-[var(--dark-grey)]">
          {{ filteredEvents.length }} {{ 'eventsShowcase.of' | translate }} {{ events.length }} {{ 'eventsShowcase.eventsCount' | translate }}
        </span>
      </div>
    </div>
  </div>

  <!-- Events Cards -->
  <div class="mx-auto max-w-screen-desktop container-padding">
    <div class="events-showcase__grid">
      <div *ngFor="let event of getDisplayEvents()" class="events-showcase__card-wrapper">

        <!-- Map view -->
        <div *ngIf="activeMapEventId === event.id" class="events-showcase__card-back">
          <app-map
            [eventBranches]="getMapEventBranches(event)"
            [customCoords]="getMapCustomCoords(event)"
            [customTitle]="event.title"
            [customLogoUrl]="event.imageUrl"
            [compact]="true"
            [enableClustering]="false"
            mapHeight="100%">
          </app-map>
          <div class="events-showcase__card-map-close"
            (click)="$event.stopPropagation(); closeMapPopupInstant()">
            <fa-icon [icon]="faTimes"></fa-icon>
          </div>
          <div class="events-showcase__card-map-title" (click)="$event.stopPropagation(); goToEvent(event)">{{ event.title }}</div>
        </div>

        <!-- Card view (reusing event-card component) -->
        <div *ngIf="activeMapEventId !== event.id" class="events-showcase__card-front-wrapper">
          <app-event-card [event]="event" [cardMode]="true" (mapClick)="openMapPopup($event)"></app-event-card>
        </div>
      </div>

      <div *ngIf="filteredEvents.length === 0 && hasActiveFilters" class="events-showcase__empty">
        <p>{{ 'eventsShowcase.noResults' | translate }}</p>
        <button (click)="clearFilters()" class="text-[var(--secondary)] font-semibold text-sm underline">
          {{ 'eventsShowcase.viewAll' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
